import React from "react";

export const LightStreaks = ({ density = 6 }) => {
  const streaks = Array.from({ length: density });
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div
        className="orb"
        style={{
          width: 520,
          height: 520,
          top: "-10%",
          left: "-10%",
          background: "rgba(0,180,255,0.18)",
        }}
      />
      <div
        className="orb"
        style={{
          width: 420,
          height: 420,
          bottom: "-15%",
          right: "-10%",
          background: "rgba(0,255,255,0.12)",
          animationDelay: "3s",
        }}
      />
      {streaks.map((_, i) => (
        <span
          key={i}
          className={`streak ${i % 3 === 0 ? "thick" : ""}`}
          style={{
            top: `${(i * 13 + 8) % 95}%`,
            animationDuration: `${6 + (i % 5) * 1.4}s`,
            animationDelay: `${i * 1.1}s`,
            opacity: 0.5,
          }}
        />
      ))}
    </div>
  );
};
